/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Interval_HelpInputs */

const en_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How frequently snapshot backups will be created`)
};

const fr_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence de création des instantanés`)
};

const de_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie häufig werden Snapshot-Backups erstellt?`)
};

const it_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con quale frequenza verranno creati i backup degli snapshot`)
};

const ru_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как часто будут создаваться резервные копии в виде моментальных снимков?`)
};

const es_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con qué frecuencia se crearán copias de seguridad de instantáneas`)
};

const zh_cn2_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照备份的创建频率如何`)
};

const ja_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スナップショットバックアップが作成される頻度`)
};

const hi_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्नैपशॉट बैकअप कितनी बार बनाए जाएंगे?`)
};

const pt_pt2_options_backup_interval_help = /** @type {(inputs: Options_Backup_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com que frequência serão criados backups instantâneos?`)
};

/**
* | output |
* | --- |
* | "How frequently snapshot backups will be created" |
*
* @param {Options_Backup_Interval_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_interval_help = /** @type {((inputs?: Options_Backup_Interval_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Interval_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_interval_help(inputs)
	if (locale === "de") return de_options_backup_interval_help(inputs)
	if (locale === "it") return it_options_backup_interval_help(inputs)
	if (locale === "ru") return ru_options_backup_interval_help(inputs)
	if (locale === "es") return es_options_backup_interval_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_interval_help(inputs)
	if (locale === "ja") return ja_options_backup_interval_help(inputs)
	if (locale === "hi") return hi_options_backup_interval_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_interval_help(inputs)
	return en_options_backup_interval_help(inputs)
});